<template>
	<div
		class="d-flex flex-column justify-center align-center"
		style="
			background-color: #d2d6de;
			background-size: cover;
			background-attachment: fixed;
			min-height: 100vh;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		"
	>
		<v-card width="360">
			<v-card-title class="title d-flex justify-center align-center mb-4" style="background-color: #003366; color: white">
				<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'" style="margin: auto"></v-img>
			</v-card-title>
			<v-card-text>
				<h1 style="margin: 15px; text-align: center; color: #003366; margin: 20px 0px 0px 0px">{{ message }}</h1>
				<h1 style="margin: 15px; text-align: center; color: #003366; margin: 5px 0px 10px 0px">{{ message2 }}</h1>
			</v-card-text>
		</v-card>
		<v-overlay style="z-index: 999" :value="$root.loader.value" opacity="0">
			<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
		</v-overlay>
	</div>
</template>

<style>
</style>

<script>
import axios from "axios";

export default {
	props: ["answerType", "meetingId", "attendeeId"],
	data() {
		return {
			message: null,
			message2: null,
			baseLocation: axios.defaults.baseURL
		};
	},
	mounted: function () {
		if (this.answerType == 'download') {
			this.$ics.removeAllEvents();
			this.download();
		} else {
			this.action();
		}
	},
	methods: {
		async action() {
			await axios
				.post("/system/public/appointment/" + this.answerType, {
					meetingId: this.meetingId,
					attendeeId: this.attendeeId
				})
				.then((response) => {
					if (response.data) {
						this.message = response.data;
						if (this.message) {
							let split = this.message.split("::")
							this.message = split[0];
							if (split.length === 2) {
								this.message2 = split[1]
							}
						}
					}
				})
				.catch(() => {});

			if (this.message == null) {
				location.href = "/#/404";
			}
		},
		download() {
			axios
				.post("/system/public/appointment/find", {
					meetingId: this.meetingId,
					attendeeId: this.attendeeId
				})
				.then((response) => {
					if (response.data) {
						let entity = response.data;
						this.$ics.addEvent(
							"en-us", // Language in format en-us (default)
							entity.title, // Subject/Title of event
							entity.message, // Description of event
							"", // Location of event
							this.makeTime(entity.startDate), // Beginning date of event
							this.makeTime(entity.endDate), // Ending date of event
							null, // URL (optional)
							null, // Organizer
							null // Reccurence rule (optional)
						);
						this.$ics.download("invite");
					}
				})
				.catch(() => {});
		},
		makeTime(obj) {
			let result = "";
			if (obj && obj.date.year) {
				result = obj.date.year + "-" + this.lpad(obj.date.month) + "-" + this.lpad(obj.date.day) + "T" + this.lpad(obj.time.hour) + ":" + this.lpad(obj.time.minute) + ":" + this.lpad(obj.time.second);
			}
			return result;
		},
		lpad(obj) {
			if (obj < 10) {
				obj = "0" + obj;
			}
			return obj;
		}
	}
};
</script>